import { BrowserRouter, Route, Routes} from "react-router-dom";
import "./App.css";
import Login from "./Components/Pages/Login&Register/Login";
import Register from "./Components/Pages/Login&Register/Register";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import Dashboard from "./Components/Pages/Dashboard/Dashboard";
import Abroad from "./Components/Pages/Abroad/Abroad";
import AddAbroad from "./Components/Pages/Abroad/AddAbroad";
import Blog from "./Components/Pages/Blog/Blog";
import ForgotPassword from "./Components/Pages/Login&Register/ForgotPassword";
import VerifyOtp from "./Components/Pages/Login&Register/VerifyOtp";
import ResetPassword from "./Components/Pages/Login&Register/ResetPassword";
import { Toaster } from "react-hot-toast";
import MyAccount from "./Components/Pages/MyAccount/MyAccount";
import Course from "./Components/Pages/Course/Course";
import Students from "./Components/Pages/Students/Students";
import NewStudent from "./Components/Pages/Students/NewStudent";
import StudentDetails from "./Components/Pages/Students/StudentDetails";
import "react-datepicker/dist/react-datepicker.css";
import 'react-circular-progressbar/dist/styles.css';
import Users from "./Components/Pages/Users/Users";
import NewUser from "./Components/Pages/Users/NewUser";
import Chat from "./Components/Pages/Chat/Chat";
import SubAdmin from "./Components/Pages/subadmin/SubAdmin";
import ProtectedRoutes from "./Components/HOC/ProtectedRoutes";

function App() {
  const toastOptions = {
    loading: {
      duration: 3000,
      theme: {
        primary: "green",
        secondary: "black",
      },
      style: {
        background: "#363636",
        color: "#fff",
        width: "100%",
      },
    },
    success: {
      duration: 3000,
      theme: {
        primary: "green",
        secondary: "black",
      },
      style: {
        background: "#363636",
        color: "#fff",
        width: "100%",
      },
    },
    error: {
      duration: 3000,
      theme: {
        primary: "green",
        secondary: "black",
      },
      style: {
        background: "#363636",
        color: "#fff",
        width: "100%",
      },
    },
  };
  return (
    <div className="App">
      <BrowserRouter >
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot/password" element={<ForgotPassword />} />
          <Route path="/verify/otp" element={<VerifyOtp />} />
          <Route path="/reset/password" element={<ResetPassword />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/abroad" element={<ProtectedRoutes allowed={["/abroad"]}>
            <Abroad />
          </ProtectedRoutes>} />
          <Route path="/abroad/add" element={<AddAbroad />} />
          <Route path="/blog" element={<ProtectedRoutes allowed={["/blog"]}><Blog /></ProtectedRoutes>} />
          <Route path="/students" element={<ProtectedRoutes allowed={["/students"]}><Students /></ProtectedRoutes>} />
          <Route path="/new/student" element={<ProtectedRoutes allowed={["/students"]}><NewStudent /></ProtectedRoutes>} />
          <Route path="/student/detail" element={<ProtectedRoutes allowed={["/students"]}><StudentDetails /></ProtectedRoutes>}/>
          <Route path="/course" element={<ProtectedRoutes allowed={["/course"]}><Course /></ProtectedRoutes>} />
          <Route path="/my/account" element={<MyAccount />} />
          <Route path="/users" element={<ProtectedRoutes allowed={["/users"]}><Users /></ProtectedRoutes>} />
          <Route path="/new/user" element={<ProtectedRoutes allowed={["/user"]}><NewUser /></ProtectedRoutes>} />
          <Route path="/prompt" element={<ProtectedRoutes allowed={['/prompt']}><Chat/></ProtectedRoutes>}/>
          <Route path="/subadmin" element={<ProtectedRoutes allowed={['/subadmin']}><SubAdmin/></ProtectedRoutes>}/>
        </Routes>
        <Toaster
          position="bottom-center"
          reverseOrder={false}
          containerClassName=""
          toastOptions={toastOptions}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
